import styled from 'styled-components';
import { theme } from '../theme';

// Profile Preview Container
export const PreviewContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  box-sizing: border-box;
`;

export const PreviewHeader = styled.div`
  padding: 2rem;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 1.25rem;
  }
`;

export const PreviewTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.5rem;

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
`;

export const PreviewDescription = styled.p`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
`;

export const PreviewContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 1.25rem;
    gap: 1.5rem;
  }
`;

export const PreviewStats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const StatItem = styled.div`
  text-align: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;

  .stat-value {
    display: block;
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin-bottom: 0.25rem;
  }

  .stat-label {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const StatValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.25rem;
`;

export const StatLabel = styled.div`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
`;

export const PreviewActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

export const ActionButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const EditButton = styled.button`
  background: linear-gradient(135deg, #ffa502 0%, #ffb142 100%);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 165, 2, 0.3);
  }
`;

export const PublishButton = styled.button`
  background: linear-gradient(135deg, #2ed573 0%, #7bed9f 100%);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(46, 213, 115, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ShareButton = styled.button`
  background: linear-gradient(135deg, #ff6b7a 0%, #ff8a9b 100%);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 122, 0.3);
  }
`;

// Profile Card Styles
export const ProfileCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const ProfilePhoto = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .placeholder {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
  }
`;

export const ProfileInfo = styled.div`
  flex: 1;
`;

export const ProfileName = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.25rem;
`;

export const ProfileAge = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.25rem;
`;

export const ProfileLocation = styled.div`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
`;

export const ProfileBio = styled.div`
  margin-bottom: 1.5rem;

  h4 {
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

export const ProfileInterests = styled.div`
  margin-bottom: 1.5rem;

  h4 {
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
`;

export const InterestTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: 16px;
  font-size: 0.8rem;
  color: white;
  margin: 0.25rem;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  .icon {
    font-size: 1rem;
  }

  .name {
    font-weight: 500;
  }
`;

export const ProfilePreferences = styled.div`
  h4 {
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
`;

export const PreferenceItem = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;

  strong {
    color: white;
    font-weight: 600;
  }
`;

// Validation Panel Styles
export const ValidationPanel = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ValidationTabs = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`;

export const ValidationTab = styled.button<{ $isActive: boolean }>`
  flex: 1;
  background: ${props => props.$isActive 
    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
    : 'transparent'};
  border: 1px solid ${props => props.$isActive 
    ? 'transparent' 
    : 'rgba(255, 255, 255, 0.3)'};
  color: white;
  padding: 0.75rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.$isActive 
      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
      : 'rgba(255, 255, 255, 0.1)'};
  }
`;

export const ValidationContent = styled.div`
  min-height: 300px;
`;

export const ValidationStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const StatusItem = styled.div<{ $isValid: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 4px solid ${props => props.$isValid ? '#2ed573' : '#ff4757'};
`;

export const StatusIcon = styled.div`
  font-size: 1.5rem;
  flex-shrink: 0;
`;

export const StatusMessage = styled.div`
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
`;

// Photo Validator Styles
export const PhotoValidatorContainer = styled.div`
  padding: 1rem;
`;

export const PhotoValidatorHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const PhotoValidatorTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
`;

export const PhotoValidatorDescription = styled.p`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
`;

export const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const PhotoItem = styled.div<{ $isValid: boolean }>`
  position: relative;
  aspect-ratio: 3/4;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid ${props => props.$isValid ? '#2ed573' : '#ff4757'};
  background: transparent;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
`;

export const PhotoPreview = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .main-badge {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    background: #2ed573;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: 600;
  }
`;

export const PhotoStatus = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StatusBadge = styled.div<{ $status: 'valid' | 'invalid' | 'main' }>`
  background: ${props => {
    switch (props.$status) {
      case 'valid': return '#2ed573';
      case 'invalid': return '#ff4757';
      case 'main': return '#667eea';
      default: return 'rgba(255, 255, 255, 0.3)';
    }
  }};
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
`;

export const ValidationDetails = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
  padding: 1rem;
  color: white;
`;

export const ValidationIssue = styled.div`
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const IssueType = styled.div<{ $severity: 'error' | 'warning' }>`
  background: ${props => props.$severity === 'error' ? '#ff4757' : '#ffa502'};
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0.25rem;
`;

export const IssueMessage = styled.div`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
`;

export const ValidationActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const RetryButton = styled.button`
  background: #ffa502;
  border: none;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #ff9500;
  }
`;

export const ApproveButton = styled.button`
  background: #2ed573;
  border: none;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #26c765;
  }
`;

export const RejectButton = styled.button`
  background: #ff4757;
  border: none;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #ff3742;
  }
`;

export const ValidationProgress = styled.div`
  margin-bottom: 2rem;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

export const ProgressText = styled.div`
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
`;

export const ValidationSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const SummaryItem = styled.div`
  text-align: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;

  .summary-value {
    display: block;
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin-bottom: 0.25rem;
  }

  .summary-label {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const SummaryValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.25rem;
`;

export const SummaryLabel = styled.div`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
`;

// Content Validator Styles
export const ContentValidatorContainer = styled.div`
  padding: 1rem;
`;

export const ContentValidatorHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const ContentValidatorTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
`;

export const ContentValidatorDescription = styled.p`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
`;

export const ValidationSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ValidationSection = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const SectionTitle = styled.h3`
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
`;

export const ItemStatus = styled.div<{ $isValid: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ItemStatusIcon = styled.div`
  font-size: 1.2rem;
`;

export const PreviewStatusMessage = styled.div`
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
`;

export const PreviewValidationDetails = styled.div`
  flex: 1;
`;

export const DetailItem = styled.div<{ $type: 'error' | 'warning' }>`
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background: ${props => props.$type === 'error' 
    ? 'rgba(255, 71, 87, 0.1)' 
    : 'rgba(255, 165, 2, 0.1)'};
  border: 1px solid ${props => props.$type === 'error' 
    ? 'rgba(255, 71, 87, 0.3)' 
    : 'rgba(255, 165, 2, 0.3)'};
  border-radius: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailLabel = styled.div<{ $type: 'error' | 'warning' }>`
  color: ${props => props.$type === 'error' ? '#ff4757' : '#ffa502'};
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

export const DetailValue = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  line-height: 1.4;
`;

export const PreviewValidationSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const PreviewValidationActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const FixButton = styled.button`
  background: #667eea;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #5a6fd8;
  }
`;

export const IgnoreButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const PreviewValidationProgress = styled.div`
  margin-bottom: 2rem;
`;

export const PreviewProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.5rem;
`;

export const PreviewProgressText = styled.div`
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
`;

export const ContentPreview = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const ContentPreviewTitle = styled.h4`
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const PreviewContentText = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const SuggestionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const SuggestionItem = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  border-left: 3px solid #667eea;
`;

export const IssueSeverity = styled.div<{ $type: 'error' | 'warning' }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  background: ${props => props.$type === 'error' 
    ? 'rgba(255, 71, 87, 0.2)' 
    : 'rgba(255, 165, 2, 0.2)'};
  color: ${props => props.$type === 'error' 
    ? '#ff4757' 
    : '#ffa502'};
  border: 1px solid ${props => props.$type === 'error' 
    ? 'rgba(255, 71, 87, 0.3)' 
    : 'rgba(255, 165, 2, 0.3)'};
`;

// Additional missing styled components
export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const PreviewCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const PreviewCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const PreviewCardTitle = styled.h3`
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const PreviewCardContent = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const PreviewCardActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const PreviewButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #5a6fd8;
    transform: translateY(-1px);
  }
`;

export const PreviewStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const SkipButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;
